import { cn } from "@/lib/cn";

/** The completed in-product mark. App icons crop this composition; product
 * surfaces use the full cup so its milk rim can blend into the background. */
export function BrandMark({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 100 100"
      fill="none"
      aria-hidden="true"
      className={cn("block", className)}
    >
      <ellipse cx="48" cy="54" rx="42" ry="43" fill="white" />
      <ellipse cx="48" cy="54" rx="35" ry="36" fill="#3FB878" />
      <path
        d="M15 56C24 36 39 32 51 37C63 43 56 53 44 59C33 64 31 74 41 79C53 85 65 76 74 62"
        stroke="white"
        strokeWidth="8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M43 74L88 14"
        stroke="#0F100E"
        strokeWidth="6"
        strokeLinecap="round"
      />
    </svg>
  );
}
